module.exports = __webpack_public_path__ + "assets/emergency-room.99ffbe7c.png";